<template>
    <Content>
        <template v-for="(listItem, key) in list">
            <section v-if="listItem.length" :key="key">
                <label v-if="title[key] || color.direction == key">
                    <span>
                        {{ color.direction == key ? color.type : title[key] }}:
                    </span>
                    <span v-if="color.direction == key" class="color-selected">
                        {{ color.name }}
                    </span>
                </label>
                <ul>
                    <template v-for="(item, index) in listItem">
                        <li
                            :key="`${key}-${index}`"
                            :class="[
                                item.is_color && 'item-grid-color',
                                item.active && 'active',
                                disabledItemGrid(item, key) &&
                                    'disabled-item-grid'
                            ]"
                            @click="handleSelect(item, key)"
                        >
                            <span v-if="!item.is_color">
                                {{ item.grid_abbreviation }}
                            </span>
                            <ProductGridColor
                                v-else
                                :color="item"
                                :disabledColor="disabledItemGrid(item, key)"
                            />
                        </li>
                    </template>
                </ul>
            </section>
        </template>
        <div v-if="validate.item_grid.$error" class="required">
            {{ messageValidator }}
        </div>
    </Content>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ProductGridColor from "../ProductGridColor";
import { Content } from "./style";

export default {
    name: "ProductItemsGrid",
    props: {
        validate: {
            required: true
        },
        item_grid: {
            default: null
        },
        local: {
            default: "page"
        }
    },
    components: {
        ProductGridColor,
        Content
    },
    data() {
        return {
            list: {
                column: [],
                row: []
            },
            title: {
                column: null,
                row: null
            },
            color: {
                type: null,
                name: null,
                direction: null
            }
        };
    },
    mounted() {
        this.setGrid();
    },
    methods: {
        ...mapActions("products", ["setResetItemsGrid"]),
        disabledItemGrid(item_grid, direction) {
            let direction_inverse = direction == "column" ? "row" : "column";
            return (
                !this.item.sell_out_of_stock &&
                (item_grid.quantity < 1 ||
                    this.minimumQuantity > item_grid.quantity) &&
                (!item_grid[direction_inverse] ||
                    !item_grid[direction_inverse].length ||
                    item_grid[direction_inverse].every(
                        el =>
                            el.quantity < 1 ||
                            this.minimumQuantity > el.quantity
                    ))
            );
        },
        handleSelect(item, type) {
            this.validate.$reset();
            this.list.row.map(e => (e.active = false));
            this.list[type].map(e => (e.active = false));
            // this.color = {
            //     type: null,
            //     name: null,
            //     direction: null
            // };
            item.active = true;

            if (type == "column") {
                let itemGrid =
                    ((!this.title?.column && !this.title?.row) ||
                        item?.single_purchase_allowed) &&
                    (item.quantity >= this.minimumQuantity || this.item.sell_out_of_stock)
                        ? item
                        : null;

                this.$emit("handleSelectItemGrid", itemGrid);

                this.title.row = item?.row
                    ? item.row[0].grid_group_name.toLowerCase()
                    : null;
                this.list.row = item?.row
                    ? item.row.map(e => {
                          e.grid_abbreviation = e.grid_abbreviation.replace(
                              `${item.grid_abbreviation} / `,
                              ""
                          );
                          return e;
                      })
                    : [];
                if (item.is_size) {
                    this.color = {
                        type: null,
                        name: null,
                        direction: null
                    };
                }
            } else {
                this.$emit("handleSelectItemGrid", item);
            }
            if (item.is_color) {
                this.color.type =
                    item.type == "COLOR"
                        ? "Cor"
                        : item.type == "ESTAMPA"
                        ? "Estampa"
                        : "";
                this.color.name = item.color_name.toLowerCase();
                this.color.direction = type;
            }
        },
        setGrid() {
            if (this.item?.items_grid_columns_and_rows) {
                if (this.item.items_grid_columns_and_rows?.column?.length) {
                    this.title.column = this.item.items_grid_columns_and_rows.column[0]?.grid_group_name?.toLowerCase();
                    this.list.column = this.item.items_grid_columns_and_rows.column
                        .map(col => {
                            if (!col?.grid_abbreviation) {
                                col.grid_abbreviation = col.grid_description;
                            } else if (
                                col.grid_abbreviation &&
                                this.title?.column
                            ) {
                                col.grid_abbreviation = col?.grid_abbreviation?.split(
                                    " /"
                                )[0];
                            }
                            if (col?.row) {
                                col.row.sort(
                                    (a, b) =>
                                        a.priority_option - b.priority_option
                                );
                            }
                            return col;
                        })
                        .sort((a, b) => a.priority_option - b.priority_option);
                    this.title.row = null;
                    this.list.row = [];
                } else {
                    this.title.row = this.item.items_grid_columns_and_rows.row[0]?.grid_group_name?.toLowerCase();
                    this.list.row = this.item.items_grid_columns_and_rows.row.sort(
                        (a, b) => a.priority_option - b.priority_option
                    );
                    this.title.column = null;
                    this.list.column = [];
                }
            }
        },
        resetItemsGridActive() {
            if (this.list?.row?.length && !this.list?.column?.length) {
                if (this.local == "modal") {
                    this.list.row = [];
                    this.title.row = null;                 
                } else {
                    this.list.row.map(r => r.active = false);
                }
                this.color = {
                    type: null,
                    name: null,
                    direction: null
                };
                return
            }
            if (this.local == "modal") {
                this.list.column = [];
                this.title.column = null;
            } else {
                this.list.column.map(column => {
                    column.active = false;
                    if (column?.row) {
                        column.row.map(row => (row.active = false));
                    }
                });
            }
            this.list.row = [];
            this.title.row = null;
            this.color = {
                type: null,
                name: null,
                direction: null
            };
        }
    },
    watch: {
        item() {
            this.setGrid();
        },
        resetItemsGrid(value) {
            if (value) {
                this.resetItemsGridActive();
                // this.setResetItemsGrid(false);
            }
        }
    },
    computed: {
        ...mapState("products", ["item", "minimumQuantity", "resetItemsGrid"]),
        ...mapGetters("products", ["showItemsGrid"]),
        messageValidator() {
            if (!this.title?.column && !this.title?.row) {
                return "* Escolha uma opção";
            }
            return `* Escolha uma opção de ${
                this.title.column && !this.title.row
                    ? this.title.column.toLowerCase()
                    : this.title.row.toLowerCase()
            }`;
        }
    }
};
</script>
